import styles from './button-styles.module.css';
import React from 'react';

export interface ButtonProps {
    children?: React.ReactNode;
    type?: 'button' | 'submit' | 'reset' | undefined;
    fullWidth?: boolean;
    outlined?: boolean;
    secondary?: boolean;
    grey?: boolean;
    onClick?: any;
    disabled?: boolean;
    disabledLight?: boolean;
    before?: React.ReactNode;
    after?: React.ReactNode;
    form?: string;
    align?: 'left' | 'center' | 'right' | 'space-between';
    color?: 'neutral';
    minWidth?: boolean;
    size?: 'base' | 'sm' | 'md' | 'xs';
    responsiveIcon?: boolean;
    style?: any;
    hasMinWidth?: boolean;
}

const Button = ({
    type,
    children,
    before,
    after,
    outlined,
    disabledLight,
    secondary,
    onClick,
    disabled,
    fullWidth,
    align,
    color,
    minWidth,
    hasMinWidth = true,
    grey,
    size = 'base',

    responsiveIcon,
    ...props
}: ButtonProps) => {
    return (
        <button
            type={type}
            className={`${styles.btn} 
            ${grey ? styles.grey : ''} 
            ${outlined ? styles.outline : ''} 
            ${secondary ? styles.secondary : ''} 
            
            ${color ? styles[`color-${color}`] : ''}
            
            ${fullWidth ? styles.fullWidth : ''} 
            ${hasMinWidth ? styles.hasMinWidth : ''} 
            ${minWidth ? styles.minWidth : ''} 
            ${align ? styles[`align-${align}`] : ''}
            ${size ? styles[`size-${size}`] : ''}
            ${disabledLight ? styles.disabledLight : ''}
            
            ${before || after ? styles.withIcon : ''}
            ${responsiveIcon ? styles.responsiveIcon : ''}
           `}
            disabled={disabled}
            onClick={onClick}
            {...props}
        >
            {before && before}
            <span className={styles.label}>{children}</span>
            {after && after}
        </button>
    );
};

export default Button;
